import cn from 'classnames'
import { memo, type ReactElement } from 'react'
import { GlobalDataExportStatus, PRETTY_DATA_EXPORT_STATUS } from '../../types/GlobalDataExportStatus'

interface StatusLabelProps {
  status: GlobalDataExportStatus
}

const STATUS_TEXT_COLORS = {
  [GlobalDataExportStatus.Pending]: '#EF7F2E',
  [GlobalDataExportStatus.Uploading]: '#EF7F2E',
  [GlobalDataExportStatus.Complete]: '#29975B',
  [GlobalDataExportStatus.Failed]: '#ef2e2e',
  [GlobalDataExportStatus.FailedUpload]: '#ef2e2e'
}

const STATUS_BG_COLORS = {
  [GlobalDataExportStatus.Pending]: '#F5EADD',
  [GlobalDataExportStatus.Uploading]: '#F5EADD',
  [GlobalDataExportStatus.Complete]: '#E1F4EC',
  [GlobalDataExportStatus.Failed]: '#e38e8e',
  [GlobalDataExportStatus.FailedUpload]: '#e38e8e'
}

function DataExportStatusLabel ({ status }: StatusLabelProps): ReactElement {
  return (
    <div
      className={
        cn(
          'rounded-sm font-semibold text-center p-2'
        )
      }
      style={{
        backgroundColor: STATUS_BG_COLORS[status],
        color: STATUS_TEXT_COLORS[status]
      }}
    >
      {PRETTY_DATA_EXPORT_STATUS[status]}
    </div>
  )
}

export default memo(DataExportStatusLabel)
